import React from 'react'
import styled from 'styled-components'
import { interactions } from 'styles'

import { Box } from 'components/Box'
import { Text } from 'components/Text'

const Root = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Link = styled(Text).attrs({
  as: 'a',
  color: 'altText',
  fontSize: 2,
})`
  ${interactions};
`

const Links = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > ${Link} + ${Link} {
    &:before {
      content: '•';
      margin-left: ${({ theme }) => theme.space[1]};
      margin-right: ${({ theme }) => theme.space[1]};
    }
  }
`

const year = new Date().getFullYear()
const FooterCredit = () => {
  return (
    <Root paddingY={3}>
      <Text color="altText" fontWeight="400" fontSize={2}>
        {year} © Stream.io, Inc. All Right Reserved.
      </Text>
      <Links marginY={1}>
        <Link interaction="opacity" href="https://getstream.io/activity-feeds/">
          Activity Feeds
        </Link>
        <Link interaction="opacity" href="https://getstream.io/chat/">
          Chat
        </Link>
        <Link interaction="opacity" href="https://getstream.io/maker-account/">
          Maker Account
        </Link>
        <Link interaction="opacity" href="https://getstream.io/contact/">
          Contact Us
        </Link>
      </Links>
    </Root>
  )
}

export default FooterCredit
